/* eslint-disable max-len */
import React from 'react';
import ActionItemsContainer from './ActionItems';
import NotesContainer from './Notes';
import './NotesActionItems.css';

const NotesActionItemsContainer = () => (
  <div className="landing-notes">
    <h4 className="title">Action Items</h4>
    <div className="content">
      <ActionItemsContainer />
      <NotesContainer />
    </div>
  </div>
);

export default NotesActionItemsContainer;
